// extracted by mini-css-extract-plugin
export default {"isInsideBlock":"ContentArea_isInsideBlock__jwmuG"};